import {Badge} from "@mantine/core";
import {
    Account,
    AccountType
} from "../types";

export const AccountTypeBadge = ({record}: { record: Account }) => {

    let color = 'gray';
    switch (record.accountType) {
        case AccountType.STANDALONE:
            color = 'blue';
            break;
        case AccountType.ROOT:
            color = 'red';
            break;
        case AccountType.MANAGED:
            color = 'orange';
            break;
        default:
            color = 'gray';
    }
    return (
        <Badge color={color}>{record.accountType}</Badge>
    )
}
